module.exports = __webpack_public_path__ + "img/layout_horizontal_icon.58b86f09.svg";